export const BLACK_FRIDAY_OFFER_END_EPOCH = 1733201999000; // epoch milliseconds value of 2024-12-02 23:59:59 EST
export const BLACK_FRIDAY_OFFER_COUPON_CODE = '3FOR324';
export const BLACK_FRIDAY_EXPRESS_CHECKOUT_PATH = `/express-checkout?planId=2&period=month&coupon=${BLACK_FRIDAY_OFFER_COUPON_CODE}`;
export const BLACK_FRIDAY_ANALYTICS_EVENT = 'black-friday-2024';
